import { defineAsyncComponent } from '../compat/vueCompat';
import { requestDialog } from './requestDialog';
import type { EventUsageRestrictionWarningDialogRequest } from './usageRestrictionWarningDialogRequest';

const EventUsageRestrictionWarningDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/EventUsageRestrictionWarningDialog.vue'));

export function showEventUsageRestrictionWarningDialog(req: EventUsageRestrictionWarningDialogRequest) {
  requestDialog(req, EventUsageRestrictionWarningDialog);
}
